// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"pages-searchQuestionUpdates-searchQuestionUpdatesListTab__checkbox--2_6Ze"};